import { useState, useEffect } from "react";
import type { Course } from "@/types/course";

export const useCourses = () => {
  const [courses, setCourses] = useState<Course[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    fetch("/data/courses.json")
      .then((res) => res.json())
      .then((data) => setCourses(data))
      .catch((err) => {
        console.error("Failed to load courses:", err);
        setError(err);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return { courses, isLoading, error };
};
